import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { FOREGROUND_SVG_PROPS } from "./constants";
export const SpotIconForeground = React.forwardRef(({ children, ...rest }, ref) => (_jsx("svg", { ...FOREGROUND_SVG_PROPS, ...rest, ref: ref, children: children })));
